import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../base";

import { useFormFieldContext } from "./context";

function LabelPreview({ ...props }) {
  const { field: { label } } = useFormFieldContext()

  return <BasePreview {...props}>
    <label>{label}</label>
  </BasePreview>
}

export default define('form-label', LabelPreview, Fragment)
  .shared(prop.share('FormLabel', 'form-label'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    fontSize: 'sm',
    textColor: 'gray-700',
  })
  .build()

